angular.module('picmonicng').directive('learnAudioPlay', [
  'LearnService',
  'BrowseService',
  '$state',
  function (LearnService, BrowseService, $state) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/learn-audio-play.html',
      link: function (scope, element, attrs) {
        scope.LearnService = LearnService;

        scope.playPauseAudio = function ($event) {
          if (LearnService.locked) return; 

          if ($state.current.name != 'app.quiz') {
            $event.stopPropagation();
          }

          if (BrowseService.browseOpen) {
            BrowseService.close();
          }
          LearnService.playPauseAudio();
          element.focus();
        };
      },
    };
  },
]);
